<template>
  <div>
    <h1 class="d-inline">{{product.title || 'Produkt hinzufügen'}}<b-badge>{{product.status}}</b-badge></h1>
    <div class="d-flex justify-content-end mb-2">
      <DeleteProductButton v-if="product.id" :product-id="product.id" class="me-2" @deleted="onProductDeleted" />
      <span class="mx-2"></span>
      <b-button v-if="product.title" variant="primary" @click="openProductPage">Produkt ansehen</b-button>
    </div>
    <div class="card p-3 w-100">
      <div class="form-group">
        <label for="title-input">Name</label>
        <b-form-input v-model="vmProduct.title" id="title-input" type="text"></b-form-input>
      </div>
      <div class="form-group">
        <label for="description">Beschreibung</label>
        <Tiptap v-model="vmProduct.descriptionHtml" id="description"/>
      </div>
      <div>
        <b-button :disabled="!changed" :variant="changed ? 'primary' : 'secondary'" @click="onSaveButton">Speichern
          <b-spinner v-if="inProgress" small></b-spinner>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Tiptap from "@/components/Tiptap";
import products from "@/api/products";
import {toNumericId} from "@/api/utils";
import collections from "@/api/collections";
import platformSettings from "~config/settings"
import DeleteProductButton from "@/components/DeleteProductButton.vue";


export default {
  props: ['product'],
  inject: ['showSuccessAlert'],
  data() {
    return {
      inProgress: false,
      showSavedConfirmation: false,
      vmProduct: {},
    }
  },
  created() {
    this.vmProduct = {
      descriptionHtml: this.product.descriptionHtml,
      title: this.product.title
    }
  },
  computed: {
    changed(){
      return Object.keys(this.vmProduct).some(field => this.vmProduct[field] !== this.product[field])
    },
    defaultTaxRateCollectionTitle(){
      return platformSettings.defaultTaxRate
    }
  },
  components: {
    DeleteProductButton,
    Tiptap
  },
  methods: {
    onProductDeleted() {
      this.$router.push('/products#deleted');
    },
    openProductPage(){
      window.open(this.product.onlineStorePreviewUrl);
    },
    onSaveButton(){
      if (this.product.id !== undefined) {
        this.saveProduct()
      }else {
        this.addProduct()
      }
    },
    saveProduct(){
      this.inProgress = true;
      products.put(
          this.product.id,
          {title: this.vmProduct.title, descriptionHtml: this.vmProduct.descriptionHtml, id: this.product.id}
      ).then( () => {
        this.showSuccessAlert('Änderungen sind gespeichert')
        this.$emit('description-updated', this.vmProduct)
      })
      .catch(
          () => {
            this.$bvModal.show('error-modal');
            this.inProgress=false;
          }
      ).finally( () => {
        this.inProgress=false
      })
    },
    addProduct(){
      let productId = null;
      this.inProgress = true;
      products.addProduct(
          {
            title: this.vmProduct.title,
            descriptionHtml: this.vmProduct.descriptionHtml
          }
      ).then(response => {
        productId = toNumericId(response.data['id']);
        return collections.getOrCreateCollectionByTitle(this.defaultTaxRateCollectionTitle)
      })
      .then( defaultTaxCollection => {
        return products.addToCollection(productId, defaultTaxCollection.id)
      })
      .then( () => {
        this.$router.push({name: "ProductForm", params: {id: productId}, query:{changed: 'true'}})
      })
      .catch(
          () => {
            this.$bvModal.show('error-modal');
          }
      ).finally(
           () => {
            this.inProgress = false
          }
      )
    }
  }
}
</script>
